import { callAction } from './client';
import { Store } from './types';

export function getStores(): Promise<Store[]> {
  return callAction<Store[]>('get_locations');
}
